import React from 'react'
import _Input from '../Field/Input/Input'

export class Input extends React.Component {
  lastSeen = null
  onValueChange = (v) => {
    if (!this.props.onValueChange) {
      return
    }
    let percentageValue
    try {
      percentageValue = typeof v === 'number' ? v : parseFloat(v.replace(/[^-\d.]/g, ''))
    } catch (e) {
      percentageValue = 0
    }
    if (!Number.isNaN(percentageValue)) {
      const val = v.length === 1 && v[0] === '-' ? v : percentageValue / 100
      this.lastSeen = val
      this.props.onValueChange?.(val)
    }
  }

  render() {
  const { value, data, onChange, percentDecimalNumber, onValueChange, ...props} = this.props
  const validRegExp = percentDecimalNumber
    ? String.raw`^[-]?\d*(?:\.\d{${props.percentDecimalNumber}})?%$`
    : String.raw`^[-]?\d*(?:\.\d+)?%$`
  const maskRegExp = percentDecimalNumber
    ? String.raw`^(?:([-]))?([\d]*)(?:(?:\.)?(\d{0,${props.percentDecimalNumber}}))?(?:%)?$`
    : String.raw`^(?:([-]))?([\d]*)(?:(?:\.)?(\d*))?(?:%)?$`
  let inputData = data ?? value
  if (inputData != null && inputData !== this.lastSeen) {
    inputData *= 100
  } else {
    inputData = undefined
  }

  return (
    <_Input
      {...props}
      validRegExp={validRegExp}
      maskRegExp={maskRegExp}
      maskReplacement='$1$2.$3%'
      onValueChange={this.onValueChange}
      data={inputData}
    />
  )
  }
}

export const Output = props => {
  const data = props.data ?? props.value ?? 0
  let parsedPercentValue = parseFloat(data) * 100
  if (parsedPercentValue && props.percentDecimalNumber) {
    parsedPercentValue = parsedPercentValue.toFixed(props.percentDecimalNumber)
  }

  return (
    <span>{`${parsedPercentValue}%`}</span>
  )
}
